import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FaFacebookF,
  FaGithub,
  FaInstagram,
  FaLinkedinIn,
  FaTimes,
  FaHome,
  FaUser,
  FaBriefcase,
  FaProjectDiagram,
  FaGraduationCap,
  FaEnvelope,
} from "react-icons/fa";

const Sidebar = ({ value, setValue, click, setClick }) => {
  const location = useLocation();

  const menuItems = [
    { path: "/", name: "Home", icon: <FaHome /> },
    { path: "/about", name: "About", icon: <FaUser /> },
    { path: "/experience", name: "Experience", icon: <FaBriefcase /> },
    { path: "/projects", name: "Projects", icon: <FaProjectDiagram /> },
    { path: "/education", name: "Education", icon: <FaGraduationCap /> },
    { path: "/contact", name: "Contact", icon: <FaEnvelope /> },
  ];

  const handleLinkClick = () => {
    setClick(!click);
    setValue(!value);
  };

  return (
    <>
      <aside
        className={click ? "modern-sidebar show-sidebar" : "modern-sidebar"}
        id="sidebar"
      >
        <div className="sidebar-overlay" onClick={handleLinkClick}></div>

        <div className="sidebar-panel">
          {/* Header Section */}
          <div className="sidebar-header">
            <div className="sidebar-logo">
              <h2>JA</h2>
              <span className="logo-subtitle">Portfolio</span>
            </div>
            <button
              className="modern-close-btn"
              id="close-btn"
              onClick={handleLinkClick}
              aria-label="Close menu"
            >
              <FaTimes />
            </button>
          </div>

          {/* Navigation Links */}
          <nav className="sidebar-nav">
            <ul className="sidebar-menu">
              {menuItems.map((item, index) => (
                <li
                  key={item.path}
                  className="sidebar-menu-item"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <Link
                    to={item.path}
                    className={
                      location.pathname === item.path
                        ? "sidebar-link active"
                        : "sidebar-link"
                    }
                    onClick={handleLinkClick}
                  >
                    <span className="link-icon">{item.icon}</span>
                    <span className="link-text">{item.name}</span>
                    <span className="link-indicator"></span>
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Divider */}
          <div className="sidebar-divider"></div>

          {/* Social Section */}
          <div className="sidebar-social-section">
            <h3 className="social-title">Connect</h3>
            <div className="sidebar-social-grid">
              <a
                href="https://www.facebook.com/junaid4u.ahmad"
                className="sidebar-social-link facebook"
                aria-label="Facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebookF />
              </a>
              <a
                href="https://www.linkedin.com/in/juac08"
                className="sidebar-social-link linkedin"
                aria-label="LinkedIn"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedinIn />
              </a>
              <a
                href="https://github.com/juac08"
                className="sidebar-social-link github"
                aria-label="GitHub"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaGithub />
              </a>
              <a
                href="https://www.instagram.com"
                className="sidebar-social-link instagram"
                aria-label="Instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram />
              </a>
            </div>
          </div>

          {/* Footer */}
          <div className="sidebar-footer">
            <p className="sidebar-footer-text">
              © {new Date().getFullYear()} Junaid Ahmad
            </p>
            <div className="sidebar-status">
              <span className="status-dot"></span>
              <span className="status-text">Available for work</span>
            </div>
          </div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
